
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M5.833 10.667a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm2.5-3.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm6.25 3.5a3.083 3.083 0 100-6.167 3.083 3.083 0 000 6.167zm2.084-3.084a2.083 2.083 0 11-4.167 0 2.083 2.083 0 014.167 0zM10.779 12c.137.098.258.226.355.383l1.391 2.249c.55.888-.09 2.035-1.134 2.035H8.61a1.333 1.333 0 01-1.134-2.035l1.391-2.25A1.33 1.33 0 019.222 12H2.917a.5.5 0 010-1h14.166a.5.5 0 010 1H10.78zm-.495.909a.333.333 0 00-.568 0l-1.39 2.249a.333.333 0 00.283.509h2.782a.334.334 0 00.284-.509l-1.392-2.25z","clip-rule":"evenodd"}})])
          )
        }
      }
    